<script setup lang="ts">
const props = defineProps<{
    md?: boolean;
    type?: string;
    data?: SocialLinks;
}>();

export type SocialLinks = {
    facebook_url?: string;
    instagram_url?: string;
    linkedin_url?: string;
    x_url?: string;
};

const socials = computed(() =>
    Object.entries(props.data || {})
        .filter(([_, value]) => value)
        .map(([key, value]) => ({
            label: key.replace('_url', ''),
            link: value as string,
        }))
);
</script>

<template>
    <ul class="flex items-center gap-2 gap-x-3" :class="{ 'gap-x-5 md:gap-x-3': props.md }">
        <li v-for="social in socials" :key="social.label">
            <a :href="social.link" :aria-label="social.label" target="_blank" class="transition-color duration-300"
                :class="props.type === 'type-cream'
                    ? 'text-cream hover:fill-white hover:text-blue'
                    : 'hover:fill-blue'
                    ">
                <span class="sr-only">{{ social.label }}</span>
                <svg class="h-[35px] w-[38px]" :class="{ 'h-[40px] w-[44px] md:h-[35px] md:w-[38px]': props.md }">
                    <use :href="`/icons/icons.svg#bubble-${social.label}`" />
                </svg>
            </a>
        </li>
    </ul>
</template>
